import {useState,useEffect} from 'react';
import { useTranslate } from 'react-redux-multilingual'
import axios from 'axios';
import swal from "sweetalert2";

const useLoadPublicTicket = (id, token) =>{
    const t = useTranslate();
    const [loading,setLoading]=useState(true)
    const [ticketDetail,setTicketDetail]=useState({})
    const [section,setSection]=useState({})
    const [companyInfos,setCompanyInfos]=useState({})
    const [moduleInfos,setModuleInfos]=useState({})
    const [pointsFidelite,setPointsFidelite]=useState({
        total:0,
        acquis:0,
        cashbackTotal:0,
        cashbackAcquis:0,
        mode:null
    })
    const [error404,setError404]=useState(false)

    useEffect(function () {
        (async function() {
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/pos/ticket_public/get_one/"+id+'/'+token
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach(interm=>messageError+=t(interm)+'. ')
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                    setLoading(false)
                }else{
                    setTicketDetail(response.data.data)
                    setSection(response.data.section)
                    setCompanyInfos(response.data.company)
                    setModuleInfos(response.data.module)
                    setPointsFidelite({
                        total:response.data.total_point_fidelite_client,
                        acquis:response.data.total_point_fidelite_ticket,
                        cashbackTotal:response.data.fidelite_client && response.data.fidelite_client.valeur_cfp ? response.data.fidelite_client.valeur_cfp : 0,
                        cashbackAcquis:response.data.valeur_cfp_ticket ? response.data.valeur_cfp_ticket : 0,
                        mode:response.data.fidelite_client ? response.data.fidelite_client.mode_fidelite : null
                    })
                    setLoading(false)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                if(error.response && error.response.status==403) setError404(true)
                swal.fire(t('unknowError'), "", "error");
                setLoading(false)
            })
        })()
    }, [])

    return [loading,ticketDetail,section,companyInfos,moduleInfos,pointsFidelite,error404]
}

export default useLoadPublicTicket;